<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="dedi"><span class="bold">Dedication</span></p>
<p class="dedi1">For all those who believe that, despite ‘hell-black nights’, another – kinder and fairer – world is possible.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedicaton.vue?9bfdd238